export default "__VITE_ASSET__C53MEmAT__"